function Hackathon() {
    return (<div>
        Our submission for the CSS x Boeing Hackathon 2022 with the theme of "Sustainable Cities and Communities". We created a navigation platform that aggregates data from 3rd party APIs and provides real-time information nearby forms of transport. When giving directions, multiple forms of transport are shown, each with predicted cost and CO2 emissions. We sadly didn't win any prizes but did receive an honourable mention and were invited to present our work at a local environmental showcase.
    </div>);
}

export default Hackathon;